import React from "react";

export default function AdminRecordCard({
  title,
  subtitle,
  fields,
  badge,
  primary,
  overflow,
  onClick,
  testId,
}) {
  return (
    <article
      className="bg-white/5 border border-white/10 p-4"
      data-testid={testId}
    >
      <button
        type="button"
        onClick={onClick}
        className="w-full text-left min-w-0"
      >
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="font-['Manrope'] font-semibold text-white truncate">{title}</p>
            {subtitle && (
              <p className="text-xs font-['Manrope'] text-white/45 mt-0.5 truncate">{subtitle}</p>
            )}
          </div>
          {badge}
        </div>
        {fields?.length > 0 && (
          <dl className="mt-3 space-y-1.5">
            {fields.map((field) => (
              <div key={field.label} className="flex items-baseline justify-between gap-3">
                <dt className="text-[11px] font-['Manrope'] text-white/40 uppercase tracking-wide shrink-0">
                  {field.label}
                </dt>
                <dd className="text-sm font-['Manrope'] text-white/80 text-right min-w-0 truncate">
                  {field.value}
                </dd>
              </div>
            ))}
          </dl>
        )}
      </button>
      {(primary || overflow) && (
        <div className="mt-3 pt-3 border-t border-white/10 flex items-center gap-2">
          {primary && <div className="flex-1 min-w-0">{primary}</div>}
          {overflow}
        </div>
      )}
    </article>
  );
}
